import React, { Component } from 'react';
import PropTypes from 'prop-types';
class VariableList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: props.list || []
    };
  }
  renderTag( tag ) {
    if( tag ){
      return (
        <div className="flex items-center text-sm bg-success" style={{ padding: '8px', borderRadius: '5px', marginRight: '5px' }}>
          {tag}
        </div>
      );
    } else {
      return (<span></span>);
    }
  }
  renderExtra( list ) {
    let count = list.length - 2;
    return (
      <span>
        {this.renderTag(`+${count}`)}
      </span>
    );
  }
  render() {
    const { __ } = this.context;
    const { list } = this.props;
    console.log("list", list);
    if( list.length > 0 ){
      return (
        <div className="flex relative mt-3 ml-3 list-element">
          { list[0] && list[0].key && this.renderTag( list[0].key ) }
          { list[1] && list[1].key && this.renderTag( list[1].key) }
          { list[2] && list[2].key && this.renderExtra(list) }
        </div>
      );
    } else {
      return (<div className="relative mt-3 ml-3 list-element">{ this.renderTag("No Variable")}</div>)
    }
  }
}

VariableList.contextTypes = {
  __: PropTypes.func
};

export default VariableList;


// WEBPACK FOOTER //
// ./src/modules/common/components/VariableList.js